
import './App.css';
import Header from "./components/utilities/Header/Header.jsx";
import Footer from "./components/utilities/Footer/Footer.jsx";
import Loginbox from "./components/utilities/Loginbox.jsx";
import Test from "./components/utilities/Test.js"


function Login() {
  return (
    <div className="Login">
      
      <Loginbox/>
      
    </div>
  );
}

export default Login;
